/* istanbul ignore file */

/**
 * Extracted as a function because currently we are not able to test `contentWindow.postMessage`
 */
export function postIframeMessage(contentWindow: Window, message: string, url: string): void {
  /* istanbul ignore next */
  contentWindow.postMessage(message, url);
}
